import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'catalog-localities',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'catalog-localities-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                                        {
                        transKey: 'breadcrumbs.official-catalogs',
                        isActive: false
                    },
                    {
                        transKey: 'breadcrumbs.catalog-localities-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "catalog-localities-index" */ '@/modules/configurations/catalogs/catalog-localities/views/Index.vue')
        }
    ]
}
